import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class AccountConsolidationRelation  {
    _originalTypeClassName = "zERP.BO.AccountConsolidationRelation";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
AccountConsolidationRelation.translate = translateService;
}
this.SourceAccountCategory = new Domain.AccountCategory();
this.AccountConsolidationRelationID = null;
this.Notes = null;
this._key = this.AccountConsolidationRelationID = 0; 
}

static translate: TranslateService;
_key: any;
private _AccountConsolidationRelationID:any;
get AccountConsolidationRelationID(): any {
    return this._AccountConsolidationRelationID;
  }
set AccountConsolidationRelationID(value: any) {
    this._AccountConsolidationRelationID = value;
    this._key = value;
  }
Notes:any;
SourceLedger:any;
TargetLedger:any;
FiscalPeriod:any;
TargetAccount:any;
SourceAccountCategory:any;
static setSourceLedger = ($this, value) => {
var oldValue = $this.SourceLedger;
$this.SourceLedger = value;
if (value != null) {
}
}
static setTargetLedger = ($this, value) => {
var oldValue = $this.TargetLedger;
$this.TargetLedger = value;
if (value != null) {
}
}
static setFiscalPeriod = ($this, value) => {
var oldValue = $this.FiscalPeriod;
$this.FiscalPeriod = value;
if (value != null) {
}
}
static setTargetAccount = ($this, value) => {
var oldValue = $this.TargetAccount;
$this.TargetAccount = value;
if (value != null) {
}
}
static setSourceAccountCategory = ($this, value) => {
var oldValue = $this.SourceAccountCategory;
$this.SourceAccountCategory = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.AccountConsolidationRelationID == null || $this.AccountConsolidationRelationID == 0;
            }


}